import { render, staticRenderFns } from "./RenewalSetting.vue?vue&type=template&id=69b08ded"
import script from "./RenewalSetting.vue?vue&type=script&lang=js"
export * from "./RenewalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports